import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelRequestStockReservation} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class RequestStockReservationFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId
    }
    return this.props.requestShippingStockReservation(updatedValues)
      .then((response) => {
        if (response.data.requestShippingStockReservation.errors.length <= 0) {
          this.props.cancelRequestStockReservation();
        } else {
          let errors = createValidationErrors(response.data.requestShippingStockReservation.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRequestStockReservation();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Reserve stock for this shipment?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const REMOVE_PACKAGE = gql`
  mutation requestShippingStockReservation($data: ShippingIdInput!) {
    requestShippingStockReservation(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(REMOVE_PACKAGE, {
    props: ({ mutate }) => ({
      requestShippingStockReservation: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelRequestStockReservation})(withMutation(RequestStockReservationFormContainer));